import { matchPath } from 'react-router-dom'

export function isEmployeeLink() {
  const match = matchPath('/:roomNumber/:connectionId', window.location.pathname)
  return match ? !!match.params.connectionId : false
}